<template>
    <div id="strategicmap" class="strategic">
        <div v-if="isMobile" class="strategic-header">
            <span style="color:F8F2D8;">{{$t("map")}}</span>
        </div>
        <div class="strategic-row">
            <div class="strategic-img"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        isMobile: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {};
    },
    components: {},
    mounted() {},
    methods: {}
};
</script>

<style lang="scss" scoped>
.strategic {
    height: 100%;
    min-height: 800px;
    padding: 70px 0 0;
    .strategic-row {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        .strategic-img {
            width: 1100px;
            height: auto;
            margin: 50px auto 0;
            background: url("~@assets/imgs/strategic-map.png") center center
                no-repeat;
            background-size: 100% auto;
        }
    }
}
@media screen and (max-width: 1440px) {
    .strategic {
        .strategic-row {
            .strategic-img {
                width: 980px;
                margin: 0 auto;
            }
        }
    }
}
// 移动端
@media screen and (max-width: 768px) {
    .strategic {
        height: auto;
        max-height: 500px;
        min-height: 250px;
        padding: 50px 0;
        .strategic-header {
            margin: 20px auto;
        }
        .strategic-row {
            .strategic-img {
                width: 550px;
                height: 400px;
                margin-top: 20px;
            }
        }
    }
}
@media screen and (max-width: 500px) {
    .strategic {
        min-height: 350px;
        padding: 0;
        .strategic-header {
            width: 100%;
            line-height: 40px;
            font-size: 14px;
            font-weight: bold;
            color: #f8f2d8;
            background: url("~@assets/imgs/bgphone-title.png") center center
                no-repeat;
            background-size: 330px 35px;
            text-align: center;
        }
        .strategic-row {
            .strategic-img {
                width: 90%;
                height: 250px;
                margin: 0;
            }
        }
    }
}
@media screen and (max-width: 375px) {
    .strategic {
        .strategic-row {
            .strategic-img {
                height: 230px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/StrategicMap.vue